<div class="dialog-container">
  <lib-dialog-header (closeClick)="closeClicked()">
    {{ config()?.title ?? '' }}
  </lib-dialog-header>
  <div class="dialog-content">
    <div>{{ config()?.message ?? '' }}</div>
    @for (message of config()?.extraMessages; track $index) {
      <div>{{ message }}</div>
    }
  </div>
  <div class="dialog-footer">
    <lib-button [type]="ButtonType.secondary" (buttonClick)="secondaryButtonClicked()">
      {{ config()?.secondaryButtonText ?? '' }}
    </lib-button>
    <lib-button [type]="ButtonType.primary" (buttonClick)="primaryButtonClicked()">
      {{ config()?.primaryButtonText ?? '' }}
    </lib-button>
  </div>
</div>
